<template>
  <v-card id="pass51" class="ep-rechner-box">
    <v-col cols="12" class="p-0">
      <div class="v-card__title p-0">
        <h2 class="v-card--head--title">{{ selectedLang.CouponTile1 }}</h2>
      </div>
    </v-col>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <div class="v-card--msg">
            <h2 class="ep-rechner-h2">{{ selectedLang.CouponTile2 }}</h2>
          </div>
        </v-col>
        <v-col cols="12" offset-sm="4" sm="4"><v-text-field v-model="couponText" :disabled="pass51" :label="selectedLang.CouponTile5"></v-text-field></v-col>
        <v-col cols="12" offset-sm="4" sm="4">
          <v-btn block :loading="loading" color="primary" :disabled="selectedDiv != '51'" @click="checkCoupon">{{
            selectedLang.CouponTile7 }}</v-btn>
        </v-col>
        <v-col v-if="sent" cols="12">
          <div class="v-card--msg">
            <h2 class="ep-rechner-h2" v-html="couponResultText"></h2>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-row v-if="selectedDiv == '51'">
        <v-col cols="12">
          <v-btn block class="btn-ep-next-step" @click="check51">{{ selectedLang.CouponTile3 }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="selectedDiv != '51' && !noChange">
        <v-col cols="12">
          <v-btn block class="btn-ep-back-to" @click="backToSpecificTile('51')">{{ selectedLang.UploadTile14 }}</v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
export default {
  name: "ResultTile",
  data: function () {
    return {
      validCoupon: false,
      couponResultText: "",
      couponText: "",
      loading: false,
      refund2C: 0,
      tanspr: 0,
      ust: 0,
      provi: 0,
      sent: false,
      showHint: false,
    };
  },
  mounted: function () { },
  computed: {
    ...mapState([
      "selectedDiv",
      "pass51",
      "noChange",
      "selectedLang",
      "user",
      "dataEP",
      "kiofCla",
    ]),
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
      "killRun",
    ]),
    async checkCoupon() {
      this.loading = true;
      await axios
        .post(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/checkCouponValue.php",
          {
            couponText: this.couponText.toUpperCase(),
            user: this.user,
          }
        )
        .then((response) => {
          this.sent = true;
          if (response.data.res == "200") {
            this.validCoupon = true;
            // var faktN = 0.8;
            // var margetotal;
            var voucherVal = 10;
            this.tanspr = parseFloat(this.dataEP.anspr.toString().replace(",", ".")) + 10.00;
            // this.refund2C = parseFloat(this.dataEP.refund2C.toString().replace(",", ".")) + 12.50;
            // this.tanspr = this.refund2C * faktN;
            // this.provi = this.refund2C - this.tanspr;
            // voucherVal = 10;

            // if (this.kiofCla == "TRF") {
            //   if (this.dataEP.t1.iy) {
            //     margetotal = parseFloat(this.provi);
            //     this.ust = 0.0;
            //   } else {
            //     margetotal = parseFloat(this.provi / 1.19);
            //     this.ust = parseFloat(this.provi - margetotal);
            //   }
            // } else {
            //   margetotal = parseFloat(this.provi / 1.19);
            //   this.ust = parseFloat(this.provi - margetotal);
            // }

            // this.tanspr = this.refund2C - this.provi;
            // this.provi = margetotal;

            this.couponResultText = this.formatDBText(
              this.selectedLang[response.data.voucherCase],
              {
                voucher: voucherVal.toFixed(2).toString().replace(".", ","),
              }
            );

            this.couponResultText =
              this.couponResultText + "<br><span class='ansprtext'>";
                this.couponResultText =
                this.couponResultText +
                this.formatDBText(this.selectedLang.ResultTile15ag, {
                  "dataEP.anspr": this.tanspr
                    .toFixed(2)
                    .toString()
                    .replace(".", ","),
                }) +
                "</span>";
            // if (this.ust == 0.0) {
            //   this.couponResultText =
            //     this.couponResultText +
            //     this.formatDBText(this.selectedLang.ResultTile15ad, {
            //       "dataEP.refund": this.refund2C
            //         .toFixed(2)
            //         .toString()
            //         .replace(".", ","),
            //       "dataEP.provi": this.provi
            //         .toFixed(2)
            //         .toString()
            //         .replace(".", ","),
            //       "dataEP.anspr": this.tanspr
            //         .toFixed(2)
            //         .toString()
            //         .replace(".", ","),
            //     }) +
            //     "</span><br><br><span class='ansprtext'>" +
            //     this.selectedLang.CouponTile12 +
            //     "</span>";
            // } else {
            //   this.couponResultText =
            //     this.couponResultText +
            //     this.formatDBText(this.selectedLang.ResultTile15ab, {
            //       "dataEP.refund": this.refund2C
            //         .toFixed(2)
            //         .toString()
            //         .replace(".", ","),
            //       "dataEP.provi": this.provi
            //         .toFixed(2)
            //         .toString()
            //         .replace(".", ","),
            //       "dataEP.ust": this.ust
            //         .toFixed(2)
            //         .toString()
            //         .replace(".", ","),
            //       "dataEP.anspr": this.tanspr
            //         .toFixed(2)
            //         .toString()
            //         .replace(".", ","),
            //     }) +
            //     "</span>";
            // }
          } else {
            this.couponResultText =
              this.selectedLang[response.data.voucherCase];
          }
        })
        .catch((error) => {
          console.log(error);
          this.couponResultText = this.selectedLang.CouponTile9;
        })
        .finally(() => (this.loading = false));
    },
    check51() {
      if (this.kiofCla == "TRF") {
        this.setSelectedDiv("60");
      } else if (this.kiofCla == "TRFDB") {
        this.setSelectedDiv("70");
      }
      this.setVar({ pos: "pass51", val: true });
      this.goToStep({ vm: this, val: this.selectedDiv });
      if (this.validCoupon) {
        //this.dataEP.provi = this.provi.toFixed(2).toString().replace(".", ",");
        //this.dataEP.ust = this.ust.toFixed(2).toString().replace(".", ",");
        this.dataEP.anspr = this.tanspr.toFixed(2).toString().replace(".", ",");
        // this.dataEP.refund = this.refund2C
        //   .toFixed(2)
        //   .toString()
        //   .replace(".", ",");
        this.dataEP.validCoupon = this.validCoupon;
        this.setVar({ pos: "dataEP", val: this.dataEP });
        this.$gtag.event("7c. Gutscheincode angewendet", {
          event_category: "Rechner",
          event_label: "7c. Gutscheincode angewendet",
        });
      } else {
        this.$gtag.event("7d. Ohne Gutscheincode fortgefahren", {
          event_category: "Rechner",
          event_label: "7d. Gutscheincode fortgefahren",
        });
      }
    },
    check32() {
      this.killRun({ vm: this });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
  },
};
</script>
